export enum AddOwnerSteps {
  PREVIEW = 'PREVIEW',
  MANUALLY = 'MANUALLY',
  IMPORT = 'IMPORT',
  IMPORT_WITH_PHOTO = 'IMPORT_WITH_PHOTO',
}
